/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Shots_RibbonsInputs */

const en_vc_shots_ribbons = /** @type {(inputs: Vc_Shots_RibbonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Blends and the Layers panel in VectorCraft`)
};

const zh_vc_shots_ribbons = /** @type {(inputs: Vc_Shots_RibbonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 的实时混合与图层面板`)
};

/**
* | output |
* | --- |
* | "Live Blends and the Layers panel in VectorCraft" |
*
* @param {Vc_Shots_RibbonsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_shots_ribbons = /** @type {((inputs?: Vc_Shots_RibbonsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Shots_RibbonsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_shots_ribbons(inputs)
	return zh_vc_shots_ribbons(inputs)
});
export { vc_shots_ribbons as "vc.shots.ribbons" }